'use client'

import { useFlags } from 'launchdarkly-react-client-sdk'

export default function CompassStyles() {
  const { tempBoss2823NewDesign } = useFlags()

  if (!tempBoss2823NewDesign) return null

  return (
    <>
      {/* eslint-disable react/no-unknown-property */}
      <link rel="stylesheet" href="https://gamma.compass.com/ucfe-assets/fonts/3/fonts.css" precedence="default" />
      <link rel="stylesheet" href="https://gamma.compass.com/ucfe-assets/cx/4/cx.css" precedence="default" />
    </>
  )
}